<template>
  <div class="funtime">
     <!--正文详情-->
     <div class="detail">
      <div class="title">我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊我是标题啊啊啊
      </div>
      <span class="publishtime">2017-03-23 17:00</span>
      <div class="detail-body"
           v-html="html"></div>

     </div>
     <!--评论列表-->
     <div class='comment'>
      <div class="comment-title">
        <span>留言</span></div>
      <ul class="ui-list">
        <li class="ui-border-t">
          <div class="ui-head">
            <span style="background-image:url(http://placeholder.qiniudn.com/100x100)"></span>
          </div>
          <div class="ui-list-info">
            <div class="name">我是用户名称</div>
            <div class="time">我是时间</div>
            <div class="content"><span>回复<label style="color:#ffc001">丁立</label>：</span>我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论我是评论</div>
          </div>
        </li>
        <li class="ui-border-t">
          <div class="ui-avatar">
            <span style="background-image:url(http://placeholder.qiniudn.com/100x100)"></span>
          </div>
          <div class="ui-list-info">
            <h4 class="ui-nowrap">这是标题，加ui-nowrap可以超出长度截断</h4>
            <p class="ui-nowrap">这是内容，加ui-nowrap可以超出长度截断</p>
          </div>
        </li>
      </ul>

     </div>
   </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      html: '<img src="http://newimg.4001113900.com//img/201608/imgs/imgs147004643047221.jpg"  /><p>&nbsp; &nbsp; 对话框很看好客户客户吾问无为谓吾问无为谓我我我我我我我我的少室山谁谁谁水水水水少室山是谁谁水水水水水水水水谁水水水水水水水水。</p>' +
          '<p>&nbsp; &nbsp; 对话框很看好客户客户吾问无为谓吾问无为谓我我我我我我我我的少室山谁谁谁水水水水少室山是谁谁水水水水水水水水谁水水水水水水水水。</p>'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .detail{
    background-color: #fff;
    padding: 1.25rem 0.75rem 0 .75rem;
  }
  .title{
    font-size: 1.05rem;
    font-weight: 700;
    color: #333333;
  }
  .publishtime{
    color: #aaaaaa;
    font-size:0.6rem;
  }
  .detail-body{
    flex:1;
    background-color: #fff;
    padding-top: 1.5rem;

  }
  .detail-body p {
    display: block;
    width: 100%;
    line-height: 1.2rem;
    padding-bottom: .75rem;
  }
  .detail-body img{
     width:100%;
     border-radius: .2rem;
  }
  .comment{
    margin-top: .4rem;
    background-color: #fff;
  }
  .comment-title{
    height: 1.75rem;
    border-bottom: 1px solid #ebebeb;
    padding: 0 .75rem;
    line-height: 1.75rem;
    vertical-align: middle;
  }
 .comment-title span {
    border-left: 3px solid #ffc001;
    padding-left: .25rem;
  }

  .ui-list > li
  {
    margin: 0 !important;
  }
  .ui-head{
    margin: .75rem;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 100%;
    overflow: hidden;
  }
  .ui-head>span{
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    background-repeat: no-repeat;
    border-radius: 100%;
  }
  .ui-list-info{
    padding: .75rem .75rem .75rem 0;
    
  }
  /*.ui-list-info span{
    display: block;
  }*/
  .ui-list-info .name{
    line-height: .75rem;
  }
  .ui-list-info .time{
    color: #aaaaaa;
    font-size: .6rem;
    line-height: .6rem;
    padding-top: .4rem;
  }
   .ui-list-info .content{
     padding-top: .5rem;
   }
</style>



// WEBPACK FOOTER //
// funTime.vue?0d732807